import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Template } from '../../../../types/working-model';
import { createNewEvent } from '../../../../store/actions/admin/create-event';
import { EventsState } from '../../../../store/types';
import Icon, { COLORS, ICONS } from '../../../general-ui/icon';
import { PATHNAMES } from "../../admin";

export const selectedTemplateKey = 'selected-template';

export default function TemplateView(props: Template): JSX.Element {
	const history = useHistory();
	const dispatch = useDispatch();
	const {
		user
	} = useSelector((state: EventsState) => state.AuthReducer);

	function selectTemplate(template: Template) {
		return () => {
			// store selected template in session storage in case of page relaod
			localStorage.setItem(selectedTemplateKey, JSON.stringify(template));
			// create the event
			dispatch(createNewEvent(user!.active_channel, template));
			history.push(PATHNAMES.EventInfo);
		};
	}

	return (
		<div className="template">
			<div className="preview-container">
				{/*
					using <img> for now so that the corners of the image aren't cut off.
					Once actual images are used, it can easily be switched to the the background image if need be.
					All sizing will remain the same.
				*/}
				<img src={props.preview_image} alt={props.name} className="preview" />
				{/* <div className="preview" style={{ backgroundImage: `url(${props.preview_image})` }}>

				</div> */}
			</div>
			<div className="info">
				<div className="info-content">
					<h3>{props.name}</h3>
					<p>{props.description}</p>

					<div className="button-row">
						<button className="primary" onClick={selectTemplate(props)}>
							Use This Template <Icon name={ICONS.ARROW_RIGHT} size={14} color={COLORS.GRAY} />
						</button>
						{/* temporarily comment out preview button until we get designs */}
						{/* <button onClick={() => alert('the preview should appear')}>
							Preview <Icon name={ICONS.NEW_WINDOW} size={14} color={COLORS.WHITE} />
						</button> */}
					</div>
				</div>
			</div>
		</div>
	);
}